export default "__VITE_ASSET__1f704beb__"